import "./healthBlog.scss";

import React from "react";

import { selectContentDictionary } from "../../reduxToolkit/features/contentSlice";
import { useAppSelector } from "../../reduxToolkit/hooks";
import { redirectToUrl } from "../../services/utilities";
import { BlogInfo } from "../../types/interfaces";
import { CarouselType } from "../../types/types";
import { CarouselProvider } from "../shared/Carousel/CarouselProvider";
import { CarouselScroll } from "../shared/Carousel/CarouselScroll";
import { CarouselSlide } from "../shared/Carousel/CarouselSlide";

export const HealthBlogCarousel = ({ blogs, carouselType, looping = true }: { blogs: BlogInfo[] | undefined; carouselType: CarouselType; looping?: boolean }) => {
    // START: GitHub Copilot Generated Code
    const contentDictionary = useAppSelector(state => selectContentDictionary(state, 'blog'));
    // contentMiddleware automatically loads content when language changes â€” no useEffect needed
    // END: GitHub Copilot Generated Code

    if (!blogs)
        return <div className='w-100 h-100 d-flex justify-content-center align-items-center'><p>{contentDictionary?.unavailable || 'Content unavailable'}</p></div>;

    const renderBlogImages = () => blogs.map((blog, index) =>
        <div key={index} className='blog-image-frame'>
            <img className='w-100 d-block' src={blog.imageUrl} alt={`image for ${blog.caption}`}
                loading={index > 0 ? undefined : 'eager'}
            />
        </div>
    );

    const renderBlogMetaInfo = () => blogs.map((blog, index) =>
        <div key={index} className='w-100 d-flex flex-column justify-content-start align-items-start'>
            {blog.caption && <div className='w-100 mb-12 blog-caption'>{blog.caption}</div>}
            {blog.link && <button className='btn primary' onClick={() => redirectToUrl(blog.link, 'new')} >{contentDictionary?.readMore || 'Read More'}</button>}
        </div>
    );

    return <CarouselProvider looping={looping} name='carousel' nSlides={blogs.length} >
        <>
            {/* {carouselType == 'Snapshot' ?
                <CarouselSlide withCaret='NonTouch' withLooping={looping} withDotGroup={true} tag='img-snapshot'>
                    {renderBlogs()}
                </CarouselSlide>
                :
                <CarouselScroll withCaret='NonTouch' withLooping={looping} withDotGroup={true} tag='img-scroll'>
                    {renderBlogs()}
                </CarouselScroll>
            } */}
            {carouselType == 'Snapshot' ?
                <CarouselSlide withCaret='NonTouch' withDotGroup={false} tag='img-snapshot'>
                    {renderBlogImages()}
                </CarouselSlide>
                :
                <CarouselScroll
                    withCaret='NonTouch'
                    withDotGroup={false}
                    tag='img-scroll'
                    transitionDurationInSeconds={2.0}
                >
                    {renderBlogImages()}
                </CarouselScroll>
            }
            {carouselType == 'Snapshot' ?
                <CarouselSlide withCaret='None' withDotGroup={true} tag='info-snapshot'>
                    {renderBlogMetaInfo()}
                </CarouselSlide> :
                <CarouselScroll
                    withCaret='None'
                    withDotGroup={true}
                    tag='info-snapshot'
                    transitionDurationInSeconds={2.0}
                >
                    {renderBlogMetaInfo()}
                </CarouselScroll>
            }
        </>
    </CarouselProvider>;
};
